<div class="container text-center mt-4" *ngIf="transferAccounts$ | async as transferAccounts">
  <h3>Transfer Successful</h3>
  <p>
    {{transferAccounts.EmailAddress}} has recieved the amount of <span class="transfer-amount">{{transferAccounts.TransferAmount | FortressCurrencyPipe: 'USD' }}</span>
  </p>
  <a class="btn btn-success" routerLink="/arenacashtransfer">
    Back to Funds
  </a>
</div>
